import { Link } from 'react-router-dom';

const articles = [
  {
    title: 'Complete Vigorbuy Spreadsheet Guide 2026',
    path: '/article/vigorbuy-spreadsheet-complete-guide',
    desc: 'Everything beginners need to know about using the Vigorbuy Spreadsheet — from finding products to comparing quality and making smart shopping decisions.',
    icon: 'ri-book-open-line',
    iconBg: 'bg-primary-100',
    iconColor: 'text-primary-600',
    img: 'https://readdy.ai/api/search-image?query=A%20bright%20clean%20desk%20flat%20lay%20with%20a%20notebook%20pen%20and%20warm%20coffee%20cup%20on%20soft%20cream%20fabric%20texture%20surface%20gentle%20morning%20sunlight%20editorial%20lifestyle%20photography%20warm%20beige%20tones&width=800&height=500&seq=card-complete-guide&orientation=landscape',
  },
  {
    title: 'Vigorbuy Spreadsheet Safety Guide',
    path: '/article/vigorbuy-spreadsheet-safety-guide',
    desc: 'Learn how to browse securely, identify trusted product links, protect personal data, and practice smart shopping safety.',
    icon: 'ri-shield-check-line',
    iconBg: 'bg-secondary-100',
    iconColor: 'text-secondary-600',
    img: 'https://readdy.ai/api/search-image?query=A%20serene%20secure%20workspace%20with%20laptop%20displaying%20lock%20icon%20next%20to%20warm%20tea%20and%20small%20plant%20on%20light%20oak%20desk%20soft%20sunlight%20through%20blinds%20peaceful%20trustworthy%20minimalist%20aesthetic&width=800&height=500&seq=card-safety&orientation=landscape',
  },
  {
    title: 'Best Sneakers from Vigorbuy Spreadsheet',
    path: '/article/best-sneakers-vigorbuy-spreadsheet',
    desc: 'Discover the best sneakers through organized footwear categories. Compare styles and find perfect sneakers for any budget.',
    icon: 'ri-footprint-line',
    iconBg: 'bg-accent-100',
    iconColor: 'text-accent-600',
    img: 'https://readdy.ai/api/search-image?query=Three%20pairs%20of%20stylish%20sneakers%20in%20cream%20beige%20and%20warm%20gray%20arranged%20on%20textured%20linen%20with%20soft%20morning%20light%20editorial%20product%20photography%20minimalist%20clean%20composition&width=800&height=500&seq=card-sneakers&orientation=landscape',
  },
  {
    title: 'Hoodie Shopping with Vigorbuy Spreadsheet',
    path: '/article/hoodie-shopping-vigorbuy-spreadsheet',
    desc: 'Master hoodie and sweater shopping. Browse streetwear styles and find quality sweatshirts across product categories.',
    icon: 'ri-t-shirt-line',
    iconBg: 'bg-primary-100',
    iconColor: 'text-primary-600',
    img: 'https://readdy.ai/api/search-image?query=Folded%20hoodies%20in%20cream%20oatmeal%20and%20warm%20taupe%20on%20soft%20wool%20throw%20blanket%20with%20warm%20drink%20gentle%20afternoon%20light%20editorial%20cozy%20lifestyle%20photography&width=800&height=500&seq=card-hoodies&orientation=landscape',
  },
  {
    title: 'How to Find Best Deals Using Vigorbuy Spreadsheet',
    path: '/article/find-best-deals-vigorbuy-spreadsheet',
    desc: 'Learn proven strategies to find the best deals, compare prices across categories, and maximize value.',
    icon: 'ri-price-tag-3-line',
    iconBg: 'bg-accent-100',
    iconColor: 'text-accent-600',
    img: 'https://readdy.ai/api/search-image?query=A%20clean%20desk%20with%20calculator%20notebook%20and%20shopping%20items%20like%20watch%20wallet%20arranged%20on%20warm%20wood%20surface%20soft%20natural%20lighting%20savvy%20shopper%20editorial%20photography&width=800&height=500&seq=card-deals&orientation=landscape',
  },
  {
    title: 'Vigorbuy Spreadsheet for Beginners',
    path: '/article/vigorbuy-spreadsheet-beginners-guide',
    desc: 'New to the spreadsheet? This friendly guide walks you through everything from database structure to first product discovery.',
    icon: 'ri-seedling-line',
    iconBg: 'bg-secondary-100',
    iconColor: 'text-secondary-600',
    img: 'https://readdy.ai/api/search-image?query=A%20welcoming%20desk%20with%20open%20notebook%20warm%20coffee%20mug%20and%20succulent%20plant%20on%20light%20wood%20surface%20soft%20morning%20sunlight%20beginner%20friendly%20approachable%20minimalist%20aesthetic&width=800&height=500&seq=card-beginners&orientation=landscape',
  },
  {
    title: 'Vigorbuy Spreadsheet Product Research',
    path: '/article/vigorbuy-spreadsheet-product-research',
    desc: 'Master product research with organized database. Analyze listings and make informed shopping decisions.',
    icon: 'ri-search-line',
    iconBg: 'bg-primary-100',
    iconColor: 'text-primary-600',
    img: 'https://readdy.ai/api/search-image?query=A%20thoughtful%20workspace%20with%20open%20notebook%20filled%20with%20neat%20handwriting%20magnifying%20glass%20and%20product%20samples%20on%20clean%20desk%20soft%20daylight%20analytical%20editorial%20photography&width=800&height=500&seq=card-research&orientation=landscape',
  },
  {
    title: 'Vigorbuy Spreadsheet Category Comparison',
    path: '/article/vigorbuy-spreadsheet-category-comparison',
    desc: 'Compare all 14 categories side by side. Find the best selection, value, and variety for your shopping needs.',
    icon: 'ri-stack-line',
    iconBg: 'bg-accent-100',
    iconColor: 'text-accent-600',
    img: 'https://readdy.ai/api/search-image?query=A%20neatly%20organized%20grid%20of%20fashion%20items%20shoes%20bag%20watch%20sunglasses%20and%20shirt%20arranged%20in%20sections%20on%20warm%20cream%20surface%20top%20down%20flat%20lay%20clean%20editorial&width=800&height=500&seq=card-compare&orientation=landscape',
  },
  {
    title: 'Top 10 Vigorbuy Spreadsheet Categories',
    path: '/article/top-vigorbuy-spreadsheet-categories',
    desc: 'Discover the top 10 most popular categories and learn which sections offer the best selection.',
    icon: 'ri-star-line',
    iconBg: 'bg-secondary-100',
    iconColor: 'text-secondary-600',
    img: 'https://readdy.ai/api/search-image?query=A%20curated%20collection%20of%20diverse%20lifestyle%20products%20sneakers%20sunglasses%20leather%20bag%20watch%20and%20perfume%20bottle%20arranged%20harmoniously%20on%20warm%20neutral%20surface%20premium%20editorial%20photography&width=800&height=500&seq=card-topcats&orientation=landscape',
  },
  {
    title: 'Vigorbuy Spreadsheet Shopping Strategy',
    path: '/article/vigorbuy-spreadsheet-shopping-strategy',
    desc: 'Build a winning shopping workflow combining category browsing, comparison techniques, and smart decision-making.',
    icon: 'ri-user-star-line',
    iconBg: 'bg-primary-100',
    iconColor: 'text-primary-600',
    img: 'https://readdy.ai/api/search-image?query=A%20strategic%20planning%20desk%20with%20notebook%20showing%20flowchart%20pen%20coffee%20cup%20and%20product%20items%20on%20warm%20wood%20surface%20soft%20natural%20light%20organized%20editorial%20photography&width=800&height=500&seq=card-strategy&orientation=landscape',
  },
];

export default function ArticleCTASection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wide uppercase mb-4">Guides &amp; Resources</span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            Vigorbuy Spreadsheet Learning Center
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            Dive deeper with our comprehensive guides covering everything from beginner tutorials to advanced product discovery strategies. Explore all 10 expert-written articles below.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {articles.map((article) => (
            <Link
              key={article.path}
              to={article.path}
              className="group flex flex-col rounded-2xl bg-white border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer overflow-hidden"
            >
              <div className="aspect-[8/5] w-full overflow-hidden bg-background-100">
                <img
                  src={article.img}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
              </div>
              <div className="flex flex-col flex-1 p-5">
                <div className="flex items-center gap-2 mb-3">
                  <div className={`w-8 h-8 rounded-lg ${article.iconBg} flex items-center justify-center flex-shrink-0`}>
                    <i className={`${article.icon} ${article.iconColor} w-4 h-4 flex items-center justify-center`}></i>
                  </div>
                  <span className="text-[10px] font-semibold text-foreground-400 uppercase tracking-wider whitespace-nowrap">Article</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 leading-snug line-clamp-2">{article.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-4 line-clamp-2 flex-1">{article.desc}</p>
                <span className="text-xs font-medium text-primary-500 group-hover:text-primary-600 transition-colors duration-200 inline-flex items-center gap-1 whitespace-nowrap mt-auto">
                  Read Article
                  <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center group-hover:translate-x-0.5 transition-transform duration-200"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 hover:bg-accent-600 text-white font-semibold rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
          >
            <i className="ri-shopping-cart-line w-4 h-4 flex items-center justify-center"></i>
            Visit Main Platform
          </a>
        </div>
      </div>
    </section>
  );
}